import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/rental/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param searchSkiRentalPrices
   * @returns {AxiosPromise}
   */
  searchAvailableSkiRentalPrices(searchSkiRentalPrices) {
    return conduit.post('search-available-prices', {
      searchSkiRentalPrices,
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-rental-service.js